const slideUp = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 20,
      stiffness: 100,
    },
  },
  exit: {
    y: '-100vh',
    opacity: 0,
  },
};

export default slideUp;
